<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title">Recived Job Applications Reports</h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <div class="card-body">
        <div class="row">
            <div class="col-md-4">
                <label>Jobs Offered </label>
                <select class="form-control" v-model="filter.JobOfferingID">
                    <option value="">---All---</option>
                    <option v-for="item in jobsOffered" v-bind:value="item.JobOfferingID">{{item.JobTitle}}</option>
                </select>
            </div>
            <div class="col-md-4">
                <label>Gender </label>
                <select class="form-control" v-model="filter.GenderID">
                    <option value="">---All---</option>
                    <option v-for="item in gender" v-bind:value="item.GenderID">{{item.Name}}</option>
                </select>
            </div>
            <div class="col-md-4">
                <label>City </label>
                <select class="form-control" v-model="filter.CityID">
                    <option value="">---All---</option>
                    <option v-for="item in city" v-bind:value="item.CityID">{{item.Name}}</option>
                </select>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Status</label>
                    <select class="form-control" v-model="filter.Status">
                        <option value="All">All</option>
                        <option value="Approved">Approved</option>
                        <option value="Rejected">Rejected</option>
                        <option value="Pending">Pending</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <label>Application Status</label>
                <select class="form-control" v-model="filter.ApplicationStatus">
                    <option value="All">--All--</option>
                    <option value="Completed">Completed</option>
                    <option value="InComplete">InComplete</option>
                </select>
            </div>
            <div class="col-md-4">
                <label>Date From</label>
                <input class="form-control" type="date" v-model="filter.DateFrom" />
            </div>
            <div class="col-md-4">
                <label>Date To</label>
                <input class="form-control" type="date" v-model="filter.DateTo" />
            </div>
            <div class="col-md-4">
                <label>Age From</label>
                <input class="form-control" v-model="filter.AgeFrom" />
            </div>
            <div class="col-md-4">
                <label>Age to</label>
                <input class="form-control" v-model="filter.AgeTo" />
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Filter by Experience</label>
                    <select class="form-control" v-model="filter.ExperienceType">
                        <option value="Omit">Omit</option>
                        <option value="All">All</option>
                        <option value="Teaching">Teaching</option>
                        <option value="Industrial">Industrial</option>
                        <option value="Administration">Administration</option>
                        <option value="Professional">Professional</option>
                    </select>
                </div>
            </div>

            <div class="col-md-2" v-if="filter.ExperienceType != 'Omit'">
                <label>Min Years</label>
                <input class="form-control" v-model="filter.Years" />
            </div>
            <div class="col-md-12">
                <br />
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" id="customCheckbox1" value="option1" v-model="IsSummary">
                    <label for="customCheckbox1" class="custom-control-label">Summary Report</label>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group float-right">
                    <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="btnSearch()">Search</button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        city: [],
        gender: [],
        jobsOffered: 0,
          filter: {
              GenderID: '', CityID: '', Status: 'All', JobOfferingID: '', AgeFrom: '', AgeTo: '',
              ApplicationStatus: 'All', Name: '', AggregateTypeID: '', Summary: false, DateFrom: '', DateTo: '',
              ExperienceType: 'Omit', Months: 0, Years: 0
          },
        applicants: [],
        aggregate: [],
        Types: 1,
        exceldata: [],
        exceldatastatus: 'default',
        delete: { id: '', ind: '' },
        IsSummary: false,
      }
    },

    created: function () {
    },

    mounted: function () {
      this.pageLoad();
    },

    updated: function () {
      if (this.applicants.length != 0) {
        $('#bs4-table').DataTable();
      }
    },

    methods: {


      pageLoad: function () {
        var vm = this;
        startReq();

        axios.post('/JobApplicationsApi/pageLoadRecivedApplications')
          .then(function (pl) {
            endReq();
            vm.gender = pl.data.gender;
            vm.city = pl.data.city;
            vm.jobsOffered = pl.data.jobOffer;
            vm.aggregate = pl.data.aggregate;
          })
      },



      btnSearch() {

       

        var vm = this;
        if (vm.filter.AgeFrom > vm.filter.AgeTo) {
          toastr.error("Age to cannot be lesser than Age from");
          return;
        }
        startReq();
        axios.post('/JobApplicationsApi/printJobApplicantReport', {
          filter: vm.filter,
        })
          .then(function (res) {
            if (res.data.status) {
              if (vm.IsSummary == true) {
                window.open("../Jobs/JobApplicantsSummaryPrint");
              }
              else {
                window.open("../Jobs/JobApplicantsReportPrint");
              }
            }
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },


    }
  })</script>

<style>
  table thead tr th {
    background-color: #605ca8;
    color: white;
  }

  blink {
    -webkit-animation: 2s linear infinite condemned_blink_effect;
  }

  @-webkit-keyframes condemned_blink_effect {

    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }

  @keyframes condemned_blink_effect {
    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/jobApplicantsReport.vue